import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getKhattabat101CStore from "../../../../stores/khattabat-stores/101c-stores";
import getKhattabat101MessagingStore from "../../../../stores/khattabat-stores/messaging-stores/101-messaging-store";
import getKhattabat102MessagingStore from "../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import Body from "./body";
import Header from "./header";
const Conversation = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors, unitY } = theme;

  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const clientID =
    conversationType === "102"
      ? getKhattabat102MessagingStore(conversationID).clientReceiverID.get()
      : getKhattabat101MessagingStore(conversationID).receiverID.get();
  const { isOneOOneCHiddenByKhattaba } = getKhattabat101CStore(clientID);

  const isOneOneCConversation = conversationType === "101C";
  const shouldNotShow =
    isOneOneCConversation && isOneOOneCHiddenByKhattaba.get();

  return shouldNotShow ? null : (
    <ET3Div
      width={1450}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{ backgroundColor: colors.all.white, minHeight: 70 * unitY }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <Header conversationID={conversationID} />
      <Body conversationID={conversationID} userID={clientID} />
    </ET3Div>
  );
});

export default Conversation;
